import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { FiX } from "react-icons/fi";

// Your existing code...


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color:#2B3497
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;
const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  margin-top:10px;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', 'Semibold';
  // color: #2B3497;
    color: #000;
  margin-bottom: 5px;
  font-weight: 600;
  &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }

`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const LocationInput = styled.input`
  border: none;
  border-bottom: 2px solid #3d46b4;
  outline: none;
  font-size: 16px;
  padding: 10px;
  margin-left: 20px;
  width: 200px;
  background: transparent;
`;

const TableContainer = styled.div`
  margin-top: 20px;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;

`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

const AddDepartmentPage = () => {
  const [showInput, setShowInput] = useState(false);
  const [departmentName, setDepartmentName] = useState('');
  const [departments, setDepartments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [isActive, setIsActive] = useState(true);

  // Sort function


  const rowsPerPage = 7;

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get('/Department');
        if (response.data) {
          // Assuming the API returns an array of departments
          setDepartments(response.data);
          setShowPagination(true); // Show pagination after submitting at least one row

        } else {
          setDepartments([]); // Ensure departments is always an array
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartments([]); // Ensure departments is always an array even if the request fails
      }
    };

    fetchDepartments();
  }, []);
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(departments, column, direction);
    setDepartments(sortedData);
  };


  const handleAddDepartmentClick = () => {
    setDepartmentName('');
    setIsActive(true);
    setIsPopupVisibleCreate(true);
  };



  const handleDepartmentSubmit = async () => {
    if (departmentName.trim() !== '') {
      try {
        const reqestData =
        {
          id: 0,
          deptDescription: departmentName,
          isDeleted: isActive ? false : true
        }
        const response = await axios.post('/Department', reqestData);
        if (response.status === 200 && response.data.code === 0 && response.data.message) {
            toast.success(response.data.message);
              // Fetch the updated list of departments
            const updatedDepartmentsResponse = await axios.get('/Department');
            setDepartments(updatedDepartmentsResponse.data ? updatedDepartmentsResponse.data : []);
            // Clear the input field
            setDepartmentName('');
            setIsPopupVisibleCreate(false);
          // Show success toast message
        } else {
            toast.error(response.data.message || 'Failed to add department');
          }
      } catch (error) {
        console.error('Error adding department:', error);
        toast.error('Error adding department');
      }
    } else {
      toast.error('Department name cannot be empty');
    }
  };
  const handleSubmitUpdate = async () => {
    if (departmentName.trim() !== '') {
      try {
        const reqestData =
        {
          id: popupData.id,
          deptDescription: departmentName,
          isDeleted: isActive ? false : true
        }
        const response = await axios.post('/Department/UpdateDepartment', reqestData);
        if (response.status === 200 && response.data.code === 0 && response.data.message) {
          toast.success(response.data.message);
          const updatedDepartmentsResponse = await axios.get('/Department');
          setDepartments(updatedDepartmentsResponse.data ? updatedDepartmentsResponse.data : []);

          // Clear the input field
          setDepartmentName('');
          setShowInput(false); // Close the input field
        } else {
          // Handle unexpected responses
          toast.error(response.data.message || 'Update unsuccessful');
        }
      } catch (error) {
        console.error('Error updating department:', error);
        toast.error('Error updating department');
      }
    } else {
      toast.error('Department name cannot be empty');
    }
    setIsPopupVisible(false);

  };
  const handleEdit = (department) => {
    console.log("Department Data", department);
    setDepartmentName(department.deptDescription);
    setIsActive(department.isDeleted ? false : true);
    setPopupData(department);
    setIsPopupVisible(true);
  };

  const handleReset = () => {
    setSearchTerm('');
    setDepartmentName('');
    setIsActive(true);
    setCurrentPage(1); // Reset pagination to the first page

  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filteredDepartments = departments.filter(department => {
    const name = department.deptDescription || ''; // Ensure a default value if departmentName is null or undefined
    return name.toLowerCase().includes(searchTerm?.toLowerCase() ?? '');
  });


  // Pagination logic
  const itemsPerPage = 7;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDepartments.slice(indexOfFirstItem, indexOfLastItem);




  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredDepartments.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredDepartments.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

  const [popupData, setPopupData] = useState('');

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <Container>
      <Header>
        <Heading>Add Department</Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </SearchBox>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button className="add-location" onClick={handleAddDepartmentClick}>
            Add Department <FiPlus size={20} />
          </Button>
          {/* {showInput && (
            <LocationInput
              type="text"
              placeholder="Enter department"
              value={departmentName}
              onChange={(e) => setDepartmentName(e.target.value)}
            />
          )} */}
        </div>
        {/* <ButtonGroup>
          <Button className="reset" onClick={handleReset}>
            Reset
          </Button>
          <Button className="submit" onClick={handleDepartmentSubmit}>
            Submit
          </Button>
        </ButtonGroup> */}
      </Card>
      <TableContainer>
        <StyledTable>
          <thead>
            <tr>
              <TableHeader colSpan={'3'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Department Details</span>
                  <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                    {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                  </IconWrapper>
                </div>
              </TableHeader>

            </tr>
          </thead>
          {isExpanded && (
            <>
              <thead>
                <tr>
                  <TableHeader onClick={() => handleSort('deptDescription')}>Department Name {sortColumn === 'deptDescription' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                  <TableHeader>IsActive</TableHeader>
                  <TableHeader>Actions</TableHeader>

                </tr>
              </thead>
              <tbody>
                {currentRows.map((department, index) => (
                  <TableRow key={index}>
                    <TableCell>{department.deptDescription}</TableCell>
                    <TableCell>{department.isDeleted ? 'No' : 'Yes'}</TableCell>
                    <TableCell>
                      <IconWrapper onClick={() => handleEdit(department)}>
                        <FiEdit />
                      </IconWrapper>
                      {/* <IconWrapper onClick={() => handleDelete(location.id)}>
                        <FiTrash2 />
                      </IconWrapper> */}
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </>
          )}
        </StyledTable>
        {isExpanded && (
          <>
            <PaginationContainer>
              <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </PaginationButton>

              <DropdownSelect value={currentPage} onChange={handlePageChange}>
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Page {i + 1}
                  </option>
                ))}
              </DropdownSelect>

              <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </>
        )}
        {isPopupVisibleCreate && (
          <Popup>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#293495' }}>Add Department</h3>
              <FiX
                style={{ cursor: 'pointer' }}
                size={20}
                onClick={() => setIsPopupVisibleCreate(false)}
              />
            </div>

            <LabelValueContainer>
              <Label>Department:</Label>
              <Value><Input
                type="text"
                placeholder="Enter Department"
                value={departmentName}
                onChange={(e) => setDepartmentName(e.target.value)}
              /></Value>
            </LabelValueContainer>
            <LabelValueContainer>
            <Label style={{ '::after': { content: 'none' } }}>IsActive:</Label>
            <Value style={{ textAlign: 'left' }}>
                <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                style={{ width: 18, height: 18, cursor: 'pointer' }}
                />
            </Value>
            </LabelValueContainer>
            <ButtonContainer>
              <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
              <PopupButton onClick={handleDepartmentSubmit}>Submit</PopupButton>
            </ButtonContainer>
            {/* Show loader when loading */}
          </Popup>
        )}
        {isPopupVisible && (
          <Popup>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#293495' }}>Update Department</h3>
              <FiX
                style={{ cursor: 'pointer' }}
                size={20}
                onClick={() => setIsPopupVisible(false)}
              />
            </div>
            <LabelValueContainer>
              <Label>Department:</Label>
              <Value><Input
                type="text"
                name="departmentUpdate"
                value={departmentName}
                onChange={(e) => setDepartmentName(e.target.value)}
                placeholder="Enter Department"
              /></Value>
            </LabelValueContainer>
            <LabelValueContainer>
            <Label style={{ '::after': { content: 'none' } }}>IsActive:</Label>
            <Value style={{ textAlign: 'left' }}>
                <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                style={{ width: 18, height: 18, cursor: 'pointer' }}
                />
            </Value>
            </LabelValueContainer>
            <ButtonContainer>
              <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
              <PopupButton onClick={handleSubmitUpdate}>Update</PopupButton>
            </ButtonContainer>
            {/* Show loader when loading */}
          </Popup>
        )}

      </TableContainer>
      <ToastContainer />

    </Container>
  );
};

export default AddDepartmentPage;
